import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#667085",
  viewBox: "0 0 20 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M14.167 16.5v-1.667a3.333 3.333 0 0 0-3.333-3.333H4.167a3.333 3.333 0 0 0-3.334 3.333V16.5m18.334 0v-1.667a3.33 3.33 0 0 0-2.5-3.225m-3.334-10a3.334 3.334 0 0 1 0 6.459m-2.5-3.234a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.667 0"
    }, null, -1)
  ]))]))
}
export default { render: render }